
import { Controller } from "react-hook-form";
import NumericFormat from "react-number-format";
import PN from "persian-number";
import { cn } from "../utils/utils";

const CustomNumberInput = (props) => {
  const { control, name, label, errors, placeholder, className } = props;

  return (
    <div
      className={cn(
        " col-span-2 xl:col-span-1 flex flex-col gap-2 ",
        className
      )}
    >
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value, disabled } }) => {
          const handleValueChange = (values) => {
           
            onChange(PN.convertPeToEn(values.formattedValue));
          };

          return (
            <>
              <label htmlFor={""}>{label}</label>
              <NumericFormat
                value={value?value:""}
                displayType={"input"}
                thousandSeparator={true}
                onValueChange={handleValueChange}
                allowNegative={false}
                placeholder={placeholder}
                      className="h-[52px] px-4  outline-none rounded-v-md  w-full border-2 border-neutral-30 disabled:bg-neutral-10 disabled:border-none"
              />
            </>
          );
        }}
      />

      {errors?.message && (
        <span className="text-red-500 text-sm">{errors?.message}</span>
      )}
    </div>
  );
};

export default CustomNumberInput;
